import { ModalBody as ModalBodyBase } from '@rodeo-dev/legos'
import styled from 'styled-components'

const ModalBody = styled(ModalBodyBase)`
  max-height: none;
`

export default ModalBody
